import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class LogManagementModel extends BaseModel {

    constructor() {
        super({ 
                name: "log_management",
                tableName: 'log_management',
                label: "Log management", 
                default_order: { key: 'updated_at', direction: 'desc' } }, 
            {
                // check_box: {
                //     name: "check_box",
                //     label: " ",
                //     type: "Computed",
                //     custom: 'CheckBoxSelect',
                //     computed: (data) => {
                //         data.check_box = '';
                //     },
                //     filter: {}
                //     // display: { list: true, add: false, edit: false }
                // },
            stt: {
                name: "stt",
                label: "No.",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_at : { 
                name: 'updated_at', 
                type: "Datetime",
                label: 'Created date',
                filter: { type: 'DateRange', match: 'contains'},
                width: 8,
            },
            type: {
                name: 'type',
                type: "String",
                label: 'Type',
                width: 15,
                class:"small-col-midle ",
                filter: {type: 'input', match: 'contains'},
            },
        

            obj_user: {
                refs: "obj_user {id fullname full_phone}",
                display: false
            },

            obj_property: {
                refs: "obj_property {id name code}",
                display: false
            },
            fullname: {
                name: 'fullname',
                type: "String",
                label: 'Who create',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.fullname = '';
                },
                width: 10,
            },
            full_phone: {
                name: 'full_phone',
                type: "String",
                label: 'Phone number',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.full_phone = '';
                },
                width: 10,
            },
            property_name: {
                name: 'property_name',
                type: "String",
                label: 'Property name',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.property_name = '';
                },
                width: 10,
            },
            property_code: {
                name: 'property_code',
                type: "String",
                label: 'Property code',
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                    data.property_code = '';
                },
                width: 10,
            },

            log_content: {
                name: 'log_content',
                type: "String",
                label: 'Log content',
                width: 15,
                class:"small-col-midle ",
                //filter: {type: 'input', match: 'contains'},
            },
            admin_note: {
                name: 'admin_note',
                type: "String",
                label: "Admin's note",
                width: 15,
                class:"small-col-midle ",
               // filter: {type: 'input', match: 'contains'},
            },
            detail_get: {
                refs:  'link_redirect is_read ',
                display: false
            },

        },)
    }

}